//
// SortDirection.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var SortDirection = {
    DATA:0,
    ASCENDING:1,
    DESCENDING:2
};
export default SortDirection;
